import { render, staticRenderFns } from "./AquariusLogs.vue?vue&type=template&id=6487f54e&scoped=true"
import script from "./AquariusLogs.vue?vue&type=script&lang=js"
export * from "./AquariusLogs.vue?vue&type=script&lang=js"
import style0 from "./AquariusLogs.vue?vue&type=style&index=0&id=6487f54e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487f54e",
  null
  
)

export default component.exports